<template>
  <div class="scrap-bd tb" v-if="funcView.scrapRecord_list">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
         <!-- v-if="funcView.in_stock_batch" -->
        <el-form-item>
          <el-button type="primary" @click="editResults" v-if="funcView.scrapRecord_modify_approval" :disabled="!editResultsList.length">
            {{funcView.scrapRecord_modify_approval}}
          </el-button>
          <el-button type="primary" @click="addScrapBatch" v-if="funcView.scrapRecord_batch">
            {{funcView.scrapRecord_batch}}
          </el-button>
        </el-form-item>
        <!-- 导出 -->
        <el-form-item style="float: right; margin-right: 0" v-if="funcView.scrapRecord_export">
          <el-button class="table-set" style="vertical-align: top" @click.native="exportTable('deviceScrapExport', formSearch)"><i class="icon icon-daochu"></i></el-button>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item style="float: right">
          <custom-column :code="tableCode" v-model="tableColumn"></custom-column>
        </el-form-item>
        <!-- 搜索项 -->
        <el-form-item style="float: right">
          <search-input v-model="formSearch.search" :placeholder="$t('dms_scrapRecord.ji_shen_hao')" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="link"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter()">
      <el-form :inline="true" label-position="top">
        <!-- 申请日期时间 -->
        <el-form-item :label="$t('dms_scrapRecord.sqrqsj')">
          <custom-date-picker style="width: 100%" v-model="formSearch.timer" type="datetimerange" value-format="YYYY-MM-DD HH:mm:ss" :picker-options="beforeToday"></custom-date-picker>
        </el-form-item>
        <!-- 库存方 -->
        <el-form-item :label="$t('dms_scrapRecord.ku_cun_fang')">
          <el-input v-model="formSearch.orgName" placeholder="" style="width: 100%"></el-input>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table height="100%" :data="tableList" :column="tableColumn" type="checkbox" v-model="tableSelect" :index="true" @filter="filterChange" @sort="sortChange" :slots="['action']">
        <template slot="action" slot-scope="scope">
          <el-button type="text" size="mini" @click="seeBtn(scope.row)" v-if="funcView.scrapRecord_preview && (scope.row.approvalState === 10 || scope.row.approvalState === 90)">
            {{ funcView.scrapRecord_preview }}
          </el-button>
          <el-button type="text" size="mini" @click="onApproval(scope.row)" v-if="funcView.scrapRecord_approval && scope.row.approvalState === 6">{{ funcView.scrapRecord_approval }}</el-button>
          <el-button type="text" size="mini" @click="editReturnType(scope.row)" v-if="funcView.scrapRecord_modify_result && scope.row.approvalState === 10">
            {{ funcView.scrapRecord_modify_result }}
          </el-button>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
    <!-- 编辑返回结果 -->
    <device-acrap-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="getTableList"></device-acrap-dialog>
    <!-- 查看 -->
    <approval-dialog v-if="dialogVisible1" :model="dialogModel1" @close="dialogVisible1 = false"></approval-dialog>
    <!-- 导入 -->
    <scrap-batch-dialog v-if="dialogVisible2" :model="dialogModel2" @close="dialogVisible2 = false" @success="onPageChange({ page: 1 })"></scrap-batch-dialog>
    <scrap-editResults-dialog v-if="dialogVisible3" :model="dialogModel3" @close="dialogVisible3 = false" @success="onPageChange({ page: 1 })"></scrap-editResults-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis.js';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins.js';
import deviceAcrapDialog from '@/pages/crm/components/deviceAcrapDialog.vue';
import approvalDialog from '@/components/approvalCenter/approval_dialog.vue';
import scrapBatchDialog from './children/scrap_batch_dialog';
import scrapEditResultsDialog from './children/scrap_editResults_dialog';

export default {
  name: 'scrapRecord',
  mixins: [resetFormSearchMixins],
  components: {
    deviceAcrapDialog,
    approvalDialog,
    scrapBatchDialog,
    scrapEditResultsDialog
  },
  data() {
    return {
      provide: true,
      tableCode: 'scrapRecord',
      formSearch: {
        search: '',
        orderType: '',
        orderBy: '',
        pageSize: 50,
        pageNum: 1,
        timer: [],
        applyStartTime: '',
        applyEndTime: '',
        orgName: ''
      },
      totalRows: null,
      tableList: [],
      dialogVisible: false,
      dialogModel: {},
      // 查看
      dialogModel1: {},
      dialogVisible1: false,
      // 批量导入
      dialogVisible2: false,
      dialogModel2: {},
      // 编辑审批结果
      dialogVisible3: false,
      dialogModel3: {},

      link: null
    };
  },
  computed: {
    editResultsList() {
      return this.tableSelect.filter(i => i.approvalState === 10);
    }
  },
  methods: {
    getTableList() {
      this.formSearch.applyStartTime = this.formSearch.timer && this.formSearch.timer[0] ? this.formSearch.timer[0] : '';
      this.formSearch.applyEndTime = this.formSearch.timer && this.formSearch.timer[1] ? this.formSearch.timer[1] : '';
      this.$getJSON(apis.deviceScrapPage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    addScrapBatch() {
      this.dialogModel2.title = this.$t('dms_scrapRecord.pi_liang_bao_fei');
      this.dialogVisible2 = true;
    },
    editResults() {
      this.dialogModel3.title = this.$t('dms_scrapRecord.xgspjg');
      this.dialogVisible3 = true;
      this.dialogModel3.data = this.editResultsList;
    },
    // 分页变更
    onPageChange({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    editReturnType(row) {
      this.dialogVisible = true;
      this.dialogModel.scrapApplyId = row.scrapApplyId;
    },
    seeBtn(row) {
      this.dialogModel1.type = 'watch';
      this.dialogModel1.changeType = row.workflowType;
      this.dialogModel1.changeId = row.batchId;
      this.dialogVisible1 = true;
    },
    onApproval(row) {
      this.jump('/examine/approvalDetail', {
        workflowType: row.workflowType,
        bizId: row.batchId,
      });
    },
  },
  mounted() {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getTableColumn();

    this.getFuncView();
    this.getTableList();
    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });
  },

};
</script>

<style></style>
